import { memo, useContext } from 'react'
import styled from 'styled-components'
import store from 'storeContext'
import logo_Black from 'assets/images/logo_astro_black.svg'

function HeadLabel() {
  const {
    state: { dataPOLiteCreatePO },
  } = useContext(store.PrintAreaContext)

  return (
    <Container>
      <ContainerLogo>
        <img src={logo_Black} style={{ width: '150px' }} />
      </ContainerLogo>
      <ContainerTitle>
        <StyledTitlePage>PURCHASE ORDER</StyledTitlePage>

        {dataPOLiteCreatePO.schedule_type?.toLowerCase() === 'poia' && (
          <StyledPoAdvance>IN ADVANCE</StyledPoAdvance>
        )}
      </ContainerTitle>
    </Container>
  )
}

export default memo(HeadLabel)

const Container = styled.div`
  display: flex;
  margin-bottom: 18px;
`

const StyledTitlePage = styled.p`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 900;
  line-height: 30px; /* 125% */
  letter-spacing: -0.072px;
`

const ContainerLogo = styled.div``
const ContainerTitle = styled.div`
  margin-left: auto;
  font-family: ${({ theme: { fontFamily } }) => fontFamily.monstreat};
  font-size: 34px;
  margin-bottom: 8px;
`

const StyledPoAdvance = styled.div`
  display: inline-block;
  border-radius: 4px;
  background-color: black;
  color: #fff;
  font-weight: bold;
  text-transform: none;
  font-size: 18px;
  padding: 2px 8px;
  letter-spacing: 0.5px;
`
